import { useIntl } from 'react-intl';
import DppModal from './DppModal';
import ReportProblemForm from '../forms/ReportProblemForm';

const ReportProblemModal = ({ show, onSave, onClose }) => {
  const intl = useIntl();
  const modalTitle = intl.formatMessage({ id: 'action_report_problem' });

  const handleSave = (data) => {
    onSave?.(data);
    onClose();
  };

  const footerButtons = (
    <></>
  );

  return (
    <DppModal
      show={show}
      handleClose={onClose}
      title={modalTitle}
      footerButtons={footerButtons}
      size="lg"
      centered
    >
      <ReportProblemForm
        onSave={handleSave}
        onCancel={onClose}
        isModal={true}
      />
    </DppModal>
  );
};

export default ReportProblemModal;